import { Outlet, useLocation } from 'react-router-dom';
import Topo from '@/pages/home/components/Topo';
import BarraApp from '@/components/feature/BarraApp';
import BotaoCarteira from '@/components/feature/BotaoCarteira';
import { MenuAppProvider } from '@/components/feature/MenuApp';
import { useModoEquipe } from '@/components/feature/ModoEquipe';

export default function Layout() {
  const { ativo } = useModoEquipe();
  const { pathname } = useLocation();
  // No modo equipe ("caixa de supermercado") não há topo nem menu: só a tela da função.
  if (ativo) return <Outlet />;
  return (
    <MenuAppProvider>
      {/* Computador: menu de cima do site. Celular: barra de cima do app. */}
      <Topo />
      <BarraApp />
      {/* Troca de tela: fade + leve deslize, 220 ms. */}
      <div key={pathname} className="pagina-entra">
        <Outlet />
      </div>
      <BotaoCarteira />
    </MenuAppProvider>
  );
}